import type { DrawerAdapter } from '@app/components/page/drawer/drawer-adapter.interface';
import { PanelProps } from 'react-resizable-panels';
import type { StreamDrawerContentType } from '../../stores/stream-screen-settings.store';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';

/**
 * Returns a DrawerAdapter for the Page drawer. Complies with DrawerAdapter so the drawer
 * uses initial state from the store (after hydration) and updates the store on open/close.
 */
export function useStreamDrawer(): DrawerAdapter {
  const initialOpen = useStreamSettingsStore((s) => !!s.drawerType);
  const updateSettings = useStreamSettingsStore((s) => s.updateSettings);

  const onOpen = (contentType?: string) => {
    updateSettings({
      drawerType: (contentType as StreamDrawerContentType) ?? null,
    });
  };

  const onClose = () => {
    updateSettings({ drawerType: null });
  };

  const panelConfig: PanelProps = {
    defaultSize: 480,
    minSize: 320,
    maxSize: 600,
  };

  return { initialOpen, onOpen, onClose, panelConfig };
}
